/**
 * API Connector - connects to real Laravel BE
 */

import { connectionCreatorApi } from "api/TenantSlug/ConnectionCreator/api";

import { syncBeIdsFromResponse, transformGraphResponseToState, transformStateToGraphRequest } from "./transformers";
import { DiagramConnector, DiagramState, SaveDiagramRequest } from "../../types";

export class ApiConnector implements DiagramConnector {
    /**
     * Load diagram data from BE
     * @param id - Scenario ID
     */
    async load(id: string): Promise<DiagramState> {
        const response = await connectionCreatorApi.getScenarioGraph(id);
        return transformGraphResponseToState(response);
    }

    /**
     * Save diagram data to BE
     * Uses PATCH response to sync beIds - no additional GET needed
     * @param id - Scenario ID
     */
    async save(id: string, data: SaveDiagramRequest): Promise<DiagramState> {
        console.log("[CC ApiConnector] Transforming state for scenario:", id);
        const request = transformStateToGraphRequest(data as DiagramState, id);
        console.log("[CC ApiConnector] Sending PUT request");
        const response = await connectionCreatorApi.updateScenarioGraph(id, request);
        console.log("[CC ApiConnector] PUT response received");

        // Sync beIds from response to current state (no extra GET needed)
        return syncBeIdsFromResponse(data as DiagramState, response);
    }

    /**
     * Check if diagram exists
     */
    async exists(id: string): Promise<boolean> {
        try {
            await connectionCreatorApi.getScenarioGraph(id);
            return true;
        } catch {
            return false;
        }
    }

    /**
     * Delete diagram - not implemented (handled elsewhere)
     */
    async delete(id: string): Promise<void> {
        throw new Error(`Delete not supported via ApiConnector. Scenario ID: ${id}`);
    }

    /**
     * Duplicate diagram - not implemented (use Blueprint feature)
     */
    async duplicate(id: string, newId: string): Promise<DiagramState> {
        throw new Error(`Duplicate not supported - use Blueprint feature. ID: ${id}, NewID: ${newId}`);
    }
}

// Singleton instance
export const apiConnector = new ApiConnector();
